import LoadingSpinner from "@/components/LoadingSpinner";
import FormatChangeConfirmation from "@/components/SchemaEditor/FormatChangeConfirmation";
import FormatWarningBanner from "@/components/SchemaEditor/FormatWarningBanner";
import { CopyButton } from "@/components/ui/copy-button";
import { observer } from "mobx-react-lite";
import { useState } from "react";
import { usePlayground } from "../../playground-store";
import { TEMPLATE_FORMATS } from "../../types";
import ImportPromptButton from "./ImportPromptButton";
import MessagesSettings from "./MessagesSettings";
import { AIPromptAssistant } from "@/components/AIPromptAsisstant";

const MessagesHeader = () => {
  const playground = usePlayground();
  const { blueprint, isSavingSession, isEditor, selectedTemplateVersion } =
    playground;
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);

  return (
    <div className="relative flex w-full flex-col">
      <FormatChangeConfirmation
        isOpen={isConfirmModalOpen}
        setIsOpen={setIsConfirmModalOpen}
      />

      <div className="flex h-[65px] w-full items-center border-b px-2">
        <div className="mr-auto flex min-w-0 items-center gap-x-2 overflow-x-auto">
          <h1 className="whitespace-nowrap text-xl font-semibold">
            Playground
          </h1>
          {isEditor && selectedTemplateVersion?.number !== undefined && (
            <span className="whitespace-nowrap rounded-md bg-blue-50 px-2 py-1 text-xs font-medium text-blue-700">
              Editing Version {selectedTemplateVersion.number}
            </span>
          )}

          {isSavingSession && <LoadingSpinner size={4} />}
        </div>

        <div className="flex shrink-0 items-center gap-x-2 pl-2">
          <ImportPromptButton />
          <AIPromptAssistant />
          <CopyButton text={JSON.stringify(blueprint, null, 2)} />
          <MessagesSettings
            readonly={playground.readonly}
            formats={TEMPLATE_FORMATS}
            currentFormat={playground.template_format}
            onFormatChange={playground.setTemplateFormat}
            isCompletion={!playground.isChat}
            onModeChange={playground.toggleMode}
            metadata={playground.metadata ?? undefined}
            setMetadata={playground.setMetadata}
          />
        </div>
      </div>

      {playground.showJinjaWarning && (
        <div className="max-h-[120px] overflow-y-auto">
          <div className="m-4">
            <FormatWarningBanner
              setIsConfirmModalOpen={setIsConfirmModalOpen}
              description={
                <>
                  <span>
                    Jinja2 detected, please switch your prompt template from{" "}
                  </span>
                  <code className="whitespace-nowrap rounded bg-gray-100 px-1.5 py-0.5 font-mono text-sm dark:bg-gray-800">
                    f-string
                  </code>
                  <span> to </span>
                  <code className="whitespace-nowrap rounded bg-gray-100 px-1.5 py-0.5 font-mono text-sm dark:bg-gray-800">
                    jinja2
                  </code>
                  <span>. </span>
                </>
              }
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default observer(MessagesHeader);
